import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "@/context/AuthContext";
import { formatCurrency, marginInfo } from "@/lib/product";

/**
 * Margepercentage voor de koper, rechtsboven over de productfoto.
 * Formule: (adviesprijs excl. BTW − jouw prijs) / adviesprijs excl. BTW.
 * De BTW komt uit de vaste tarieven per land (alleen voor deze berekening).
 */
export const MarginBadge = ({ product, className = "" }) => {
  const { t, i18n } = useTranslation();
  const { account } = useAuth();
  const marge = marginInfo(product, account);
  if (!marge) return null;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`pointer-events-auto absolute right-2 top-2 z-10 inline-flex items-center rounded-full border border-primary/25 bg-primary/90 px-2.5 py-1 text-xs font-semibold text-primary-foreground shadow-sm backdrop-blur ${className}`}
            data-testid="margin-badge"
            data-margin={marge.percentage}
          >
            {t("margin.badge", { pct: marge.percentage })}
          </span>
        </TooltipTrigger>
        <TooltipContent side="left" className="max-w-[240px]">
          <p data-testid="margin-badge-tooltip">
            {t("margin.tooltip", {
              advies: formatCurrency(marge.adviesExcl, i18n.language),
              prijs: formatCurrency(marge.prijs, i18n.language),
              tarief: marge.btw,
            })}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
